var map = {
	"./AM_Competency_Framework.svg": 49650,
	"./AM_Competency_Framework_zh.svg": 7627,
	"./AddAnnotations.svg": 9086,
	"./AudioResponseThumbnail.svg": 11114,
	"./CandidateProfileChapter.svg": 19748,
	"./CandidateResponseChapter.svg": 53122,
	"./Cutoffcircle.svg": 81792,
	"./IPAddress.svg": 53008,
	"./IPBinding.svg": 28811,
	"./OS_NoScore.svg": 97485,
	"./OS_NotApplicable.svg": 37504,
	"./OS_NotAttempted.svg": 12973,
	"./OS_NotCompleted.svg": 89374,
	"./OS_ScoringInReview.svg": 7102,
	"./OS_ScoringPending.svg": 91728,
	"./ProbesChapter.svg": 94305,
	"./Q.svg": 2664,
	"./ReferenceVideoThumbnail.svg": 92197,
	"./VideoResponseThumbnail.svg": 73031,
	"./WarningImg1.svg": 5139,
	"./annotation_view.svg": 95740,
	"./arrow_gray.svg": 57524,
	"./arrow_white.svg": 43824,
	"./arrow_white_down.svg": 83463,
	"./audioDetected.svg": 86873,
	"./audioThumbnail.svg": 12845,
	"./audioThumbnailLight.svg": 94515,
	"./autofaceDetect.svg": 15116,
	"./automata-user-audio.svg": 67846,
	"./blue_check.svg": 38302,
	"./blue_cross.svg": 31934,
	"./blue_pause.svg": 73156,
	"./blue_play.svg": 77100,
	"./blue_scroll.svg": 34777,
	"./bold.svg": 81998,
	"./bold_B.svg": 23773,
	"./browserToggle.svg": 30965,
	"./call-icon.svg": 43547,
	"./captionOff.svg": 56522,
	"./captionOn.svg": 40052,
	"./close-grey.svg": 56035,
	"./close.svg": 7733,
	"./close_red.svg": 59805,
	"./code-status0.svg": 31969,
	"./code-status1.svg": 17168,
	"./collapse-all.svg": 49340,
	"./collapse_up.svg": 86142,
	"./comments-icon.svg": 60333,
	"./completedStatus.svg": 35192,
	"./completedTick.svg": 37537,
	"./copyPaste.svg": 83609,
	"./correct.svg": 76015,
	"./cross.svg": 58045,
	"./cutoff-scale.svg": 80169,
	"./delete.svg": 10154,
	"./devArea.svg": 20947,
	"./down.svg": 51603,
	"./downloadIcon-old.svg": 12376,
	"./downloadIcon.svg": 46720,
	"./draggable.svg": 53512,
	"./edit-icon-active.svg": 16194,
	"./edit-icon-inactive.svg": 54063,
	"./email-icon.svg": 17405,
	"./enter.svg": 29571,
	"./error-summary-icon.svg": 7226,
	"./errorTC.svg": 69640,
	"./evalCompleted.svg": 69284,
	"./evalPending.svg": 50518,
	"./exitPlayback.svg": 888,
	"./exitfullscreen.svg": 33588,
	"./expand-all.svg": 87953,
	"./expand-window.svg": 85276,
	"./expand_down.svg": 6074,
	"./faceNotMatched.svg": 95017,
	"./flaggedProctoringCardCurve.svg": 68833,
	"./fullScreen.svg": 76628,
	"./fullscreen.svg": 22708,
	"./geoLocation.svg": 87319,
	"./govtIdVerification.svg": 14753,
	"./grey_scroll.svg": 17098,
	"./grid-icon-active.svg": 78378,
	"./grid-icon-inactive.svg": 80215,
	"./highSimilarity.svg": 99502,
	"./icon_evaluated.svg": 5362,
	"./icon_pending.svg": 27800,
	"./incorrect.svg": 14248,
	"./info.svg": 79339,
	"./info_grey.svg": 80303,
	"./language_mobile.svg": 74742,
	"./learningResourcesDict/paymentType_1.svg": 23227,
	"./learningResourcesDict/paymentType_2.svg": 41864,
	"./learningResourcesDict/source_1.svg": 34020,
	"./learningResourcesDict/source_2.svg": 88471,
	"./learningResourcesDict/source_3.svg": 99494,
	"./learningResourcesDict/source_4.svg": 68905,
	"./learningResourcesDict/type_1.svg": 16263,
	"./learningResourcesDict/type_2.svg": 44756,
	"./left.svg": 74148,
	"./less_up.svg": 94844,
	"./link-45deg.svg": 4583,
	"./linkingIcons/CandidateProfileChapter.svg": 52409,
	"./linkingIcons/CandidateResponseChapter.svg": 26609,
	"./linkingIcons/ProbesChapter.svg": 35336,
	"./magnifying_glass.svg": 40373,
	"./mediaNotFoundIcon.svg": 37863,
	"./more_down.svg": 44067,
	"./multiLineInsertion.svg": 73531,
	"./multiface_detection.svg": 24673,
	"./multipleFacesDetected.svg": 86425,
	"./mute.svg": 35304,
	"./next.svg": 30484,
	"./noFaceDetected.svg": 86043,
	"./no_search_item_found.svg": 60584,
	"./not-attempted.svg": 94961,
	"./notStarted.svg": 44381,
	"./participantNotMatched.svg": 52387,
	"./pause.svg": 87235,
	"./pencil.svg": 15008,
	"./pendingStatus.svg": 70974,
	"./pip_button.svg": 79765,
	"./play.svg": 55789,
	"./playCircle.svg": 87445,
	"./prev.svg": 38772,
	"./printscreen.svg": 30416,
	"./question-icon.svg": 1823,
	"./questions.svg": 48114,
	"./replay-icon-active.svg": 279,
	"./replay-icon-inactive.svg": 67238,
	"./replay.svg": 5170,
	"./right.svg": 61579,
	"./right_green.svg": 23079,
	"./saveStatus.svg": 79010,
	"./saved.svg": 24776,
	"./saving.svg": 53021,
	"./search-icon.svg": 42611,
	"./search.svg": 91599,
	"./shlLogo.svg": 85607,
	"./smallDropDownIcon.svg": 13144,
	"./started.svg": 44038,
	"./subsectionIcons/21_0_socialskills_tmp.svg": 20231,
	"./subsectionIcons/21_0_spokenenglish_tmp.svg": 79318,
	"./subsectionIcons/21_0_workplaceskills_tmp.svg": 89814,
	"./suspiciousObjectsDetected.svg": 7348,
	"./svg-icons/Info iconinfo.svg": 98788,
	"./svg-icons/accordion-close.svg": 23978,
	"./svg-icons/accordion-open.svg": 67126,
	"./svg-icons/avatar.svg": 10638,
	"./svg-icons/blue-check-icon.svg": 36860,
	"./svg-icons/cancel.svg": 49383,
	"./svg-icons/download.svg": 91725,
	"./svg-icons/dropdown-down-bg.svg": 51289,
	"./svg-icons/expand.svg": 4465,
	"./svg-icons/nav-Left.svg": 9454,
	"./svg-icons/nav-right.svg": 76013,
	"./svg-icons/play-circular.svg": 43299,
	"./svg-icons/to-top.svg": 36032,
	"./svg-icons/warning-error.svg": 39458,
	"./sys_status_correct.svg": 54200,
	"./sys_status_incorrect.svg": 84459,
	"./systemRequirements/browser.svg": 94597,
	"./systemRequirements/download-speed.svg": 99869,
	"./systemRequirements/flash-player.svg": 66611,
	"./systemRequirements/latency.svg": 77403,
	"./systemRequirements/microphone.svg": 3467,
	"./systemRequirements/os.svg": 4125,
	"./systemRequirements/processor.svg": 89773,
	"./systemRequirements/ram.svg": 89097,
	"./systemRequirements/screen-resolution.svg": 70578,
	"./systemRequirements/speaker.svg": 18150,
	"./systemRequirements/upload-speed.svg": 55730,
	"./systemRequirements/webcam.svg": 86048,
	"./tab-icon-active.svg": 36673,
	"./tab-icon-inactive.svg": 7252,
	"./threshold.svg": 90604,
	"./thumbs-down.svg": 74621,
	"./thumbs-side.svg": 91816,
	"./thumbs-up.svg": 28770,
	"./tick.svg": 39104,
	"./toggleDown.svg": 17587,
	"./topLeftTriangleRed_16x16.svg": 10687,
	"./topLeftTriangleRed_32x32.svg": 75995,
	"./unmute.svg": 24829,
	"./user-icon.svg": 62636,
	"./video-next.svg": 7434,
	"./video-prev.svg": 37094,
	"./viewInterviewIcon.svg": 41866,
	"./visualReview.svg": 88187,
	"./voiceDetected.svg": 48585,
	"./volume.svg": 57249,
	"./volumeoff.svg": 53888,
	"./warning.svg": 94137,
	"./warningIcon.svg": 2374,
	"./warningInfoIcon.svg": 45034,
	"./warningPop.svg": 89466,
	"./wrong_red.svg": 56026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36599;